<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'

import axios from "axios";

const SITES_API_URL = process.env.VUE_APP_API_URL + 'sites';
const ANIMATIONS_API_URL = process.env.VUE_APP_API_URL + 'dashboard/animations-controller';

/**
 * Kanban-board component
 */
export default {
  page: {
    title: 'Animations manager',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  async mounted() {
    // Set the initial number of items
    await this.fetchSites();
  },
  computed: {
    /**
     * Total no. of records
     */
  },
  methods: {
    moveAll(enable) {
      if (!this.groups) {
        return
      }
      if (enable) {
        this.groups[1].items = this.sites;
        this.groups[0].items = []
        return
      }

      this.groups[0].items = this.sites;
      this.groups[1].items = []
    },
    async fetchSites() {
      const fetchSitesResponse = await axios(SITES_API_URL + '/all/sites');
      this.sites = fetchSitesResponse.data;
      this.groups[0].items = this.sites.filter(site => !site.config.animationsEnabled)
      this.groups[1].items = this.sites.filter(site => site.config.animationsEnabled)
    },
    async handleSubmit() {
      this.submitting = true;

      const enabled = this.groups[1].items.map(x => x.id)
      const disabled = this.groups[0].items.map(x => x.id)

      try {
        await axios.put(ANIMATIONS_API_URL, {enabled, disabled});
      } catch (e) {
        console.log(e)
      } finally {
        this.submitting = false;
      }
    }
  },
  data() {
    return {
      submitting: false,
      filter: '',
      sites: [],
      groups: [
        {
          id: 1,
          status: '⛔ Animations Disabled',
          description: 'Animations Disabled Subtitle',
          items: [

          ],
          action: {
            name: 'Disable All',
            action: () => this.moveAll(false)
          }
        },
        {
          id: 2,
          status: '✅ Animations Enabled',
          description: 'Animations Enabled Subtitle',
          items: [
          ],
          action: {
            name: 'Enable All',
            action: () => this.moveAll(true)
          },
        },
      ],
      title: 'Animations Manager',
      items: [
        {
          text: 'Home',
          href: '/',
        },
        {
          text: 'animations',
          active: true,
        },
      ],

      options: {
        dropzoneSelector: '.drag-inner-list',
        draggableSelector: '.drag-item',
      },
    }
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-sm-12 col-md-12">
        <div id="tickets-table_filter" class="col-sm-12 col-md-12 dataTables_filter text-md-right justify-content-lg-between d-inline-flex align-items-center">
          <label class="d-inline-flex align-items-center ">
            Search:
            <b-form-input
                v-model="filter"
                type="search"
                placeholder="Search..."
                class="form-control form-control-sm ml-2"
            ></b-form-input>
          </label>
          <button
              type="submit"
              class="btn btn-primary ml-1 mb-2"
              @click="handleSubmit"
              :disabled="submitting"
          >Submit
          </button>
        </div>
      </div>
      <div v-drag-and-drop:options="options" class="drag-container col-sm-12 col-md-12">
        <div class="row drag-list">
          <div v-for="group in groups" :key="group.id" class="col-lg-6 drag-column">
            <div class="card-box">
              <!-- dropdown -->
              <b-dropdown right variant="white" class="float-right" toggle-class="p-0">
                <template slot="button-content">
                  <i class="mdi mdi-dots-vertical m-0 text-muted h3"></i>
                </template>
                <b-dropdown-item v-if="group && group.action" @click="group.action.action"> {{ group.action.name }}</b-dropdown-item>
              </b-dropdown>
              <span class="drag-column-header">
                <h4 class="header-title">{{ group.status }}</h4>
                <p class="sub-header"> {{ group.description }}</p>
              </span>

              <vue-draggable-group v-model="group.items" :groups="groups" :data-id="group.id">
                <ul
                  :data-id="group.id"
                  class="sortable-list taskList list-unstyled ui-sortable drag-inner-list"
                >
                  <li
                    v-for="item in group.items.filter(x => x.domain.includes(filter))"
                    :key="item.id"
                    :data-id="item.id"
                    class="drag-item py-1 px-2"
                  >
                    <span
                      class="badge float-right"
                      :class="{
                        'bg-soft-danger text-danger': `${item.task}` === 'High',
                        'bg-soft-success text-success': `${item.task}` === 'Low',
                        'bg-soft-warning text-warning': `${item.task}` === 'Medium' }"
                    >{{ item.task}}</span>
                    <h5 class="mt-0 mb-0">
                      <a href="javascript: void(0);" class="text-dark">{{ item.domain }}</a>
                    </h5>
                    <p class="mb-0 publisher-subtitle">{{ item.publishers && item.publishers.length && item.publishers[0].name }}</p>
                    <div class="clearfix"></div>
                  </li>
                </ul>
              </vue-draggable-group>

            </div>
          </div>
          <!-- end col-->
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<style>
.publisher-subtitle {
  font-size: 12px;
}
</style>
